// extracted by mini-css-extract-plugin
export default {"second_section":"fitness_second_section__NEM5d","first":"fitness_first__ZKiVJ","second":"fitness_second__p3V-y"};